<template>
    <div class="drop collapse mt-5" id="addCardBlock">
        <PaymentForm
            ref="paymentForm"
            :input_countries="countries"
            :input_states="states"
            @create="createPayment"
        >
        </PaymentForm>
    </div>
</template>

<script>
    import { googleAutocomplete } from '../../mixins/google-autocomplete';
    import PaymentForm from "../Common/PaymentForm";

    export default {
        name: "PaymentCardBillingCreate",
        components: {
            PaymentForm
        },
        mixins: [ googleAutocomplete ],
        props: {
            countries: {
                type: Array,
                required: true
            },
            states: {
                type: Array,
                required: true
            }
        },
        methods: {
            createPayment(payment) {
                this.$emit('create', payment);
            }
        }
    }
</script>
